module.exports = __webpack_public_path__ + "static/media/hp-catalog-hz-md.e2644331.jpeg";